export default "__VITE_ASSET__BgWyWnp7__"